import React, { useEffect, useState, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import { fetchHouseRules, updateHouseRulesThunk } from "../../slices/staticPages/thunk";
import { resetHouseRulesFlag } from "../../slices/staticPages/reducer";
import { CKEditor } from "@ckeditor/ckeditor5-react";
import ClassicEditor from "@ckeditor/ckeditor5-build-classic";
import { Container } from "reactstrap";
import BreadCrumb from "../../Components/Common/BreadCrumb";

function HouseRules() {
  const dispatch = useDispatch();
  const state = useSelector((state) => state);

  const houseRules = state?.StaticPages?.houseRules || {};

  // CKEditor Data State
  const [editorData, setEditorData] = useState(null);

  // Fetch content on mount
  useEffect(() => {
    dispatch(fetchHouseRules());
  }, [dispatch]);

  // Set API response into editor
  useEffect(() => {
    if (houseRules?.data?.htmlContent !== undefined) {
      setEditorData(houseRules.data.htmlContent || "");
    }
  }, [houseRules?.data?.htmlContent]);

  // Save Updated Content
  const handleSave = () => {
    dispatch(updateHouseRulesThunk({ htmlContent: editorData }));
  };

  // Reset success flag
  useEffect(() => {
    if (houseRules?.success) {
      const timer = setTimeout(() => dispatch(resetHouseRulesFlag()), 3000);
      return () => clearTimeout(timer);
    }
  }, [houseRules?.success, dispatch]);

  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
          <BreadCrumb title="House Rules" pageTitle="House Rules" />
        </Container>
      </div>

      <div className="static-page"
        style={{
          marginBottom: "55px",
          background: "white",
          padding: "1rem",
        }}
      >
        <label className="form-label fw-bold">HTML Content</label>

        {/* CKEditor */}
        <div className="border p-2">
          <CKEditor
            editor={ClassicEditor}
            data={editorData}
            onChange={(event, editor) => {
              try {
                setEditorData(editor.getData());
              } catch (e) {
                console.error("Editor error:", e);
              }
            }}
          />
        </div>

        <button
          className="btn btn-primary mt-3"
          disabled={houseRules?.loading}
          onClick={handleSave}
        >
          {houseRules?.loading ? "Saving..." : "Save"}
        </button>

        {/* Preview */}
        <h5 className="form-label fw-bold mt-4">Preview</h5>
        <div
          style={{
            border: "1px solid #ccc",
            padding: "15px",
            borderRadius: "4px",
            minHeight: "100px",
          }}
          dangerouslySetInnerHTML={{ __html: editorData }}
        />
      </div>
    </React.Fragment>
  );
}

export default HouseRules;
